import { mediaQuery } from 'modules/utils';

export const textClamp = (clamp?: { maxLines?: number; lineHeight?: string }) =>
  clamp &&
  `--max-lines: ${clamp.maxLines || 2};
    --lh: ${clamp.lineHeight};
    display: -webkit-box;
    -webkit-line-clamp: var(--max-lines);
    -webkit-box-orient: vertical;
    overflow: hidden;
    ${
      clamp.lineHeight ? 'max-height: calc(var(--lh) * var(--max-lines))' : ''
    }`;

export const buttonFullWidthMobile = (width?: React.CSSProperties['width']) => `
  width: 100%;
  button {
    width: 100%;
  }

  ${mediaQuery('md')} {
    button {
      width: ${width || 'auto'};
    }
  }`;

export const setIconColor = (color: string) => `
  * {
    g,
    path {
      fill: ${color};
    }
  }
`;

export const SkeletonSmallSize = {
  width: '5rem',
  minWidth: '3rem',

  height: '1.5rem',
};
